import { useNavigate } from "react-router";
import { CohartsHero } from "../components/home/CohartsHero";
import { ProductIntro } from "../components/home/ProductIntro";
import { HomeLifecycle } from "../components/home/HomeLifecycle";
import { HomeEvidence } from "../components/home/HomeEvidence";
import { HomeAudiences } from "../components/home/HomeAudiences";
import { FinalStatement } from "../components/home/FinalStatement";
import { BookDemo } from "../components/demo/BookDemo";

export function HomePage() {
  const navigate = useNavigate();

  return (
    <div>
      <CohartsHero onExploreIviz={() => navigate("/iviz")} onDiscoverForesight={() => navigate("/foresight")} />
      <ProductIntro
        onIviz={() => navigate("/iviz")}
        onForesight={() => navigate("/foresight")}
        onPricing={() => navigate("/pricing")}
        onDemo={() => navigate("/contact/foresight")}
      />
      <HomeLifecycle />
      <HomeEvidence onEvidence={() => navigate("/evidence")} />
      <HomeAudiences />
      <section className="bg-[#FAFAFA] px-6 py-20 dark:bg-[#050505] lg:px-10">
        <div className="mx-auto max-w-[1400px]">
          <BookDemo
            location="home_demo_callout"
            variant="card"
            title="Bring us the decision you are trying to make."
            description="We will show how Foresight can support your clinical program with a live, relevant example."
          />
        </div>
      </section>
      <FinalStatement onExploreIviz={() => navigate("/iviz")} onDiscoverForesight={() => navigate("/foresight")} />
    </div>
  );
}
